import { render, staticRenderFns } from "./Head.vue?vue&type=template&id=73121cc6&scoped=true"
import script from "./Head.vue?vue&type=script&lang=js"
export * from "./Head.vue?vue&type=script&lang=js"
import style0 from "./Head.vue?vue&type=style&index=0&id=73121cc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73121cc6",
  null
  
)

export default component.exports